import { useQuery } from "@tanstack/react-query"
import { getTpvTypes } from "./sales"
import { salesKeys } from "./queryKeys"
import type { IGetTpvTypesParams } from "./types"

export const useGetTpvTypesQuery = (params?: IGetTpvTypesParams) => {
  return useQuery({
    queryKey: salesKeys.tpvTypes(params),
    queryFn: () => getTpvTypes(params),
  })
}
